import { ApiException, post } from 'utils/fetch'
import { apiPrefix } from 'constants/api'

export type ApplyCooperationOptipns = {
  contactName: string
  contactPhone: string
  wechat?: string
  ISP: string // 运营商，多条以,分隔
  networkType?: string // 网络类型
  usbwDesc: string // 单条带宽大小
  magnitudeBW: string // 资源量级
  provinces?: string // 省份
  source?: string // 渠道来源
}

type JarvisErrorResult = {
  code?: number
  desc?: string
}

export async function applyCooperation(options: ApplyCooperationOptipns): Promise<JarvisErrorResult> {
  const res: JarvisErrorResult = await post(`${apiPrefix}/v1/businesses`, options)
  if (typeof res?.code === 'number') {
    throw new ApiException(res, '提交失败', res.code)
  }
  return res
}
